import { ok } from '@xlearn/common';
import { setCMIString64000 } from './cmi-string.actions';

export function getSuspendData(value: string) {
  return ok(value);
}

export function setSuspendData(current: string, value: string) {
  return setCMIString64000(current, value);
}

